import {
  AwesomeTableComponent,
  Button,
  IColumnsProps,
  Notifications,
} from "d-react-components";
import React, { ElementRef, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useFindAllRoleLazyQuery,
  useFindUnassignedRoleListLazyQuery,
  useUpdateUserByAdminMutation,
} from "../../../../network/hooks";
import { userUserInfo } from "../UserDetail";
import { ADMIN_AUTH_KEY } from "../../../../constants/common";
import { useLocalStorage } from "react-use";

const UserChannelUpdate = ({ onClose }: { onClose: () => void }) => {
  const [refetch, { data }] = useFindUnassignedRoleListLazyQuery();
  const [{ user, loading }] = userUserInfo();
  const { t } = useTranslation();
  const [query, setQuery] = useState("");
  const tableRef = useRef<any>(null);
  const [selectedRows, setSelectedRows] = useState<Array<any>>(
    (user?.roles ?? []).map((i: any) => i.id)
  );
  const [updateUser] = useUpdateUserByAdminMutation();
  const [admin, setAdmin] = useLocalStorage<any>(ADMIN_AUTH_KEY);

  const loadTableData = (paging: any) => {
    return refetch({
      variables: {
        userId: user?.id as string,
        args: {
          page: paging.pageIndex,
          limit: paging.pageSize,
          search: {
            query,
          },
        },
      },
    });
  };
  const tableColumns: IColumnsProps = useMemo(
    () => [
      {
        title: t("common:roleId"),
        dataIndex: "roleId",
        align: "left",
        width: 60,
        render: (data, item) => data,
      },
      {
        title: t("common:name"),
        dataIndex: "name",
        align: "left",
        width: 75,
        render: (data: any, item: any, index) => data,
      },
    ],
    [t]
  );

  const handleSubmit = async () => {
    try {
      updateUser({
        variables: {
          input: {
            id: user?.id as string,
            roles: selectedRows,
          },
        },
      }).then(
        (resp) => {
          Notifications.showSuccess(
            t("notification:userProfileUpdatedSuccessfully")
          );
          setAdmin({ ...admin, ...resp?.data?.updateUserByAdmin });
          onClose && onClose();
        },
        (err) => {
          Notifications.showError(err);
        }
      );
    } catch (err) {
      Notifications.showError(err);
    }
  };

  return (
    <div>
      {/* @ts-ignore */}
      <AwesomeTableComponent
        source={loadTableData}
        transformer={(res) => {
          return res?.data?.findUnassignedRole?.data ?? [];
        }}
        getTotalItems={(res) => {
          return res?.data?.findUnassignedRole?.pagination?.items ?? 0;
        }}
        columns={tableColumns}
        ref={tableRef}
        showSelectColumn={false}
        selectingRows={selectedRows}
        rowSelection={{
          onChange: (value) => setSelectedRows(value),
          selectedRowKeys: selectedRows,
          preserveSelectedRowKeys: true,
        }}
      />
      <div>
        <div className="flex align-items-end justify-content-end">
          <Button
            title={t("common:submit")}
            className="w-full mb-2 text-sm"
            onClick={() => handleSubmit()}
            color="primary"
          >
            {t("common:send")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserChannelUpdate;
